var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isClamped)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(_vm._s(_vm.clampedText)+"…")])]}}],null,false,4060749757)},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('span',[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }